import configs from "../configs/apiConfigs";
import { BODY_TYPE, CommonApiOptions, METHOD_TYPE } from "../constants/api";
import { commonApi } from "../helpers/api";
import { attachHeader } from "../utils/apiHandler";


export interface Observation {
  id: number;
  category: string;
  description: string;
  impact: "Positive" | "Negative" | "Neutral";
}

export interface Recommendation {
  id: number;
  category: string;
  description: string;
  priority: "High" | "Medium" | "Low";
}

export interface ObservationsResponse {
  status: {
    error: boolean;
    msg: string;
  };
  observations: Observation[];
}

export interface RecommendationsResponse {
  status: {
    error: boolean;
    msg: string;
  };
  recommendations: Recommendation[];
}

export const addObservation = async (clinicUniqueId: string, observationData: any): Promise<ObservationsResponse> => {
  const request: CommonApiOptions = {
    url: `${configs.API_URL}addobservation/${clinicUniqueId}/`,
    method: METHOD_TYPE.POST,
    body: {
      type: BODY_TYPE.RAW,
      data: observationData,
    },
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    }
  };

  return commonApi(request);
};

export const updateObservation = async (clinicUniqueId: string, observationData: any): Promise<ObservationsResponse> => {
  const request: CommonApiOptions = {
    url: `${configs.API_URL}updateobservation/${clinicUniqueId}/`,
    method: METHOD_TYPE.POST,
    body: {
      type: BODY_TYPE.RAW,
      data: observationData,
    },
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    }
  };

  return commonApi(request);
};

export const deleteObservation = async (clinicUniqueId: string, observationData: any): Promise<ObservationsResponse> => {
  const request: CommonApiOptions = {
    url: `${configs.API_URL}deleteobservation/${clinicUniqueId}/`,
    method: METHOD_TYPE.POST,
    body: {
      type: BODY_TYPE.RAW,
      data: observationData,
    },
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    }
  };

  return commonApi(request);
};

export const getObservations = async (clinicUniqueId: string, month: string, year: string): Promise<ObservationsResponse> => {

  const request: CommonApiOptions = {
    url: `${configs.API_URL}observationlist/${clinicUniqueId}/?month=${month}&year=${year}`,
    method: METHOD_TYPE.GET,
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };

  return commonApi(request);

};

export const getRecommendations = async (clinicUniqueId: string, month: string, year: string): Promise<RecommendationsResponse> => {

  const request: CommonApiOptions = {
    url: `${configs.API_URL}recommendationlist/${clinicUniqueId}/?month=${month}&year=${year}`,
    method: METHOD_TYPE.GET,
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };

  return commonApi(request);

};

export const addRecommendation = async (clinicUniqueId: string, recommendationData: any): Promise<RecommendationsResponse> => {
  const request: CommonApiOptions = {
    url: `${configs.API_URL}addrecommendation/${clinicUniqueId}/`,
    method: METHOD_TYPE.POST,
    body: {
      type: BODY_TYPE.RAW,
      data: recommendationData,
    },
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    }
  };

  return commonApi(request);
};

export const updateRecommendation = async (clinicUniqueId: string, recommendationData: any): Promise<RecommendationsResponse> => {
  const request: CommonApiOptions = {
    url: `${configs.API_URL}updaterecommendation/${clinicUniqueId}/`,
    method: METHOD_TYPE.POST,
    body: {
      type: BODY_TYPE.RAW,
      data: recommendationData,
    },
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    }
  };

  return commonApi(request);
};

export const deleteRecommendation = async (clinicUniqueId: string, recommendationData: any): Promise<RecommendationsResponse> => {
  const request: CommonApiOptions = {
    url: `${configs.API_URL}deleterecommendation/${clinicUniqueId}/`,
    method: METHOD_TYPE.POST,
    body: {
      type: BODY_TYPE.RAW,
      data: recommendationData,
    },
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    }
  };

  return commonApi(request);
};

